<template>
  <div class="pathologies">
    <div class="information_header">
      <h1>Справочник заболеваний</h1>
    </div>    
    <div class="pathologies_headline">     
      <div class="pathologies_left">
        <div class="pathologies_search">
          <label for="search_name">Поиск по коду или названию</label>
          <input
            id="search_name"
            v-model="search"
            class="pathologies_search-input"
          />
          <svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path fill-rule="evenodd" clip-rule="evenodd" d="M11.6679 11.6679C12.0584 11.2774 12.6916 11.2774 13.0821 11.6679L15.7071 14.2929C16.0976 14.6834 16.0976 15.3166 15.7071 15.7071C15.3166 16.0976 14.6834 16.0976 14.2929 15.7071L11.6679 13.0821C11.2774 12.6916 11.2774 12.0584 11.6679 11.6679Z" fill="#4854FE"/>
            <path fill-rule="evenodd" clip-rule="evenodd" d="M7.125 2C4.29454 2 2 4.29454 2 7.125C2 9.95546 4.29454 12.25 7.125 12.25C9.95546 12.25 12.25 9.95546 12.25 7.125C12.25 4.29454 9.95546 2 7.125 2ZM0 7.125C0 3.18997 3.18997 0 7.125 0C11.06 0 14.25 3.18997 14.25 7.125C14.25 11.06 11.06 14.25 7.125 14.25C3.18997 14.25 0 11.06 0 7.125Z" fill="#4854FE"/>
          </svg>
        </div>
      </div>
      <div class="pathologies_right">
      </div>
    </div>
    <v-data-table
      class="elevation-1"
      ref="table"
      :key="tableKey"
      :headers="headers"
      :items="pathologiesData"
      item-key="id"
      @pagination="paginations($event)"
      :page="page"      
      :items-per-page="itemsPerPage"
      :search="search"
      hide-default-footer
      >
      <template v-slot:item="{ item }">
        <tr>
          <td class="text-center">
            <v-btn v-if="item.subtypes.length > 0" @click="item.openSubtypes = !item.openSubtypes" small icon>
							<v-icon>
								{{ item.openSubtypes ? 'mdi-chevron-down' : 'mdi-chevron-right' }}
							</v-icon>
						</v-btn>
          </td>
          <td>{{ item.code }}</td>
          <!-- <td class="text-center">
            <v-btn v-if="item.symptoms.length > 0" @click="item.openSymptoms = !item.openSymptoms" small icon>
							<v-icon>
								{{ item.openSymptoms ? 'mdi-chevron-down' : 'mdi-chevron-right' }}
							</v-icon>
						</v-btn>
          </td> -->
          <td>
            {{ item.name }}<br />
            <a v-if="item.symptoms.length > 0" @click="openSymptoms(item)">{{item.symptoms.length}} симптом(ов)</a>
          </td>
          <td style="text-align: end;">
            <v-tooltip v-if="item.subtypes.length === 0 || item.openSubtypes" bottom>
							<template v-slot:activator="{ on, attrs }">
								<v-icon @click="addSubtype(item)" v-bind="attrs" v-on="on" color="#1976d2" class="mr-1">mdi-plus-circle</v-icon>
							</template>
							<span>Добавить примечание</span>
						</v-tooltip>
            <v-tooltip bottom>
							<template v-slot:activator="{ on, attrs }">
								<v-icon @click="editPathology(item.id)" v-bind="attrs" v-on="on">mdi-pencil-box-outline</v-icon>
							</template>
							<span>Редактировать</span>
						</v-tooltip>
          </td>
        </tr>
        <!-- <tr v-if="item.openSymptoms">
          <td colspan="3"></td>
          <td colspan="2">
            <table style="width: 100%" class="elevation-2">
              <tbody>
                <tr v-for="indicator in item.symptoms" :key="indicator.id" class="border-bottom: 1px gray solid">
                  <td class="td-is-open px-3">
                    {{ indicator.indicatorName }}
                  </td>
                  <td class="td-is-open" style="text-align: end;">
                    <v-tooltip bottom>
											<template v-slot:activator="{ on, attrs }">
												<v-icon @click="openIndicator(indicator, item, false)" v-bind="attrs" v-on="on" small class="mr-2">mdi-eye</v-icon>
											</template>
											<span>Просмотр</span>
										</v-tooltip>
                  </td>
                </tr>
              </tbody>
            </table>
          </td>
        </tr> -->
        <template v-if="item.openSubtypes">
          <template v-for="subtype in item.subtypes">
            <tr :key="subtype.id">
              <td></td>
              <td></td>
              <!-- <td class="text-center">
                <v-btn v-if="subtype.symptoms.length > 0" @click="subtype.openSymptoms = !subtype.openSymptoms" small icon>
                  <v-icon>
                    {{ subtype.openSymptoms ? 'mdi-chevron-down' : 'mdi-chevron-right' }}
                  </v-icon>
                </v-btn>
              </td> -->
              <td>
                {{ subtype.note }}<br />
                <a v-if="subtype.symptoms.length > 0" @click="openSymptoms(subtype)">{{subtype.symptoms.length}} симптом(ов)</a>
              </td>
              <td style="text-align: end;">
                <v-tooltip bottom>
                  <template v-slot:activator="{ on, attrs }">
                    <v-icon @click="editPathology(subtype.id)" v-bind="attrs" v-on="on">mdi-pencil-box-outline</v-icon>
                  </template>
                  <span>Редактировать</span>
                </v-tooltip>
              </td>
            </tr>
            <!-- <tr v-if="subtype.openSymptoms" :key="subtype.id">
              <td colspan="3"></td>
              <td colspan="2">
                <table style="width: 100%" class="elevation-2">
                  <tbody>
                    <tr v-for="indicator in subtype.symptoms" :key="indicator.id" class="border-bottom: 1px gray solid">
                      <td class="td-is-open px-3">
                        {{ indicator.indicatorName }}
                      </td>
                      <td class="td-is-open" style="text-align: end;">
                        <v-tooltip bottom>
                          <template v-slot:activator="{ on, attrs }">
                            <v-icon @click="openIndicator(indicator, subtype, false)" v-bind="attrs" v-on="on" small class="mr-2">mdi-eye</v-icon>
                          </template>
                          <span>Просмотр</span>
                        </v-tooltip>
                      </td>
                    </tr>
                  </tbody>
                </table>
              </td>
            </tr> -->
          </template>
        </template>        
      </template>
      <template v-slot:footer="{ props }">
        <div class="data-footer">
          <div class="items-per-page">
            <span>Строк на странице:</span>
            <div class="items-per-page_item" :class="{active: itemsPerPage == 5}" @click.prevent="itemsPerPage = 5">
              5
            </div>
            <div class="items-per-page_item" :class="{active: itemsPerPage == 10}" @click.prevent="itemsPerPage = 10">
              10
            </div>
            <div class="items-per-page_item" :class="{active: itemsPerPage == 15}" @click.prevent="itemsPerPage = 15">
              15
            </div>
            <div class="items-per-page_item" :class="{active: itemsPerPage == -1}" @click.prevent="itemsPerPage = -1">
              все
            </div>
          </div>
          <div class="pagination" v-if="itemsPerPage != -1">
            <div class="pagination_prev" @click.prevent="page == 1 ? page : --page">
              <svg width="6" height="11" viewBox="0 0 6 11" fill="none" xmlns="http://www.w3.org/2000/svg">
              <path d="M4.81409 0.210823C4.94325 0.0744081 5.10763 -4.46523e-07 5.30137 -4.6346e-07C5.68884 -4.97335e-07 6 0.322435 6 0.731679C6 0.936302 5.91781 1.12232 5.78278 1.26494L1.67319 5.5062L5.78278 9.73506C5.91781 9.87768 6 10.0699 6 10.2683C6 10.6776 5.68885 11 5.30137 11C5.10763 11 4.94325 10.9256 4.81409 10.7892L0.246575 6.07666C0.0821913 5.91545 0.00587038 5.71702 -4.80825e-07 5.5C-4.99798e-07 5.28298 0.0821913 5.09696 0.246575 4.92954L4.81409 0.210823Z" fill="#94969C"/>
              </svg>
            </div>
            <div class="pagination_number">
              {{ props.pagination.pageStart + 1 }} - {{ props.pagination.pageStop }} из {{props.pagination.itemsLength}}
            </div>
            <div class="pagination_next" v-if="itemsPerPage" @click.prevent="page == props.pagination.pageCount ? page : ++page">
              <svg width="6" height="11" viewBox="0 0 6 11" fill="none" xmlns="http://www.w3.org/2000/svg">
              <path d="M1.18591 0.210823C1.05675 0.0744081 0.892369 -4.46523e-07 0.698631 -4.6346e-07C0.311156 -4.97335e-07 9.33462e-07 0.322435 8.97685e-07 0.731679C8.79796e-07 0.936302 0.0821928 1.12232 0.217222 1.26494L4.32681 5.5062L0.217221 9.73506C0.082192 9.87768 8.13121e-08 10.0699 6.39655e-08 10.2683C2.81882e-08 10.6776 0.311155 11 0.69863 11C0.892368 11 1.05675 10.9256 1.18591 10.7892L5.75343 6.07666C5.91781 5.91545 5.99413 5.71702 6 5.5C6 5.28298 5.91781 5.09696 5.75343 4.92954L1.18591 0.210823Z" fill="#94969C"/>
              </svg>
            </div>
          </div>
        </div>
      </template>
      <v-progress-linear
          :active="loadingTable"
          :indeterminate="loadingTable"
          absolute
          bottom
          color="primary accent-4"
        ></v-progress-linear>
    </v-data-table>

    <v-dialog v-model="pathologyDialog.show" max-width="900px" persistent>
			<v-card>
				<v-toolbar dark color="#001e46">
					<v-toolbar-title style="color: rgba(129, 182, 228, 0.95)">
						{{ pathologyDialog.update ? 'Редактировать заболевание' : 'Добавить подтип заболевания' }}
					</v-toolbar-title>

					<v-spacer></v-spacer>

					<v-toolbar-items>
						<v-btn icon color="rgba(129, 182, 228, 0.95)" @click="closePathology">
							<v-icon>mdi-close</v-icon>
						</v-btn>
					</v-toolbar-items>
				</v-toolbar>

				<v-card-text class="pb-0">
					<v-container>
						<v-form ref="pathologyForm" v-model="pathologyDialog.valid" lazy-validation>
              <v-row>
								<v-col cols="12" sm="12" md="12" class="mt-5">
									<v-text-field outlined dense hide-details v-model="pathologyDialog.target.name" disabled label="Наименование заболевания" />
								</v-col>
							</v-row>
							<v-row>
								<v-col cols="12" sm="12" md="12">
									<v-text-field outlined dense hide-details v-model="pathologyDialog.target.code" disabled label="Код заболевания" />
								</v-col>
							</v-row>
              <v-row v-if="!idIsEmpty(pathologyDialog.target.parentId)">
								<v-col cols="12" sm="12" md="12">
									<v-textarea outlined dense hide-details :rules="[rules.required]" v-model="pathologyDialog.target.note" rows="3" no-resize label="Примечание" />
								</v-col>
							</v-row>
						</v-form>
					</v-container>
				</v-card-text>

				<v-card-actions class="pb-5">
					<v-spacer></v-spacer>

					<v-btn v-if="!idIsEmpty(pathologyDialog.target.parentId)" :loading="sendingRequest" @click="!sendingRequest ? closePathology() : ''" color="blue darken-1" dark>Отмена</v-btn>
					<v-btn v-if="!idIsEmpty(pathologyDialog.target.parentId)" :loading="sendingRequest" @click="!sendingRequest ? savePathology(pathologyDialog.target) : ''" color="success" dark>Сохранить</v-btn>
          <v-btn v-if="pathologyDialog.update" :loading="sendingRequest" @click="!sendingRequest ? openSymptoms(pathologyDialog.target) : ''" color="blue lighten-1" dark>Редактор симптомов</v-btn>
				</v-card-actions>
			</v-card>
		</v-dialog>

    <v-dialog v-model="indicatorDialog.show" max-width="1200px" persistent>
			<v-card>
				<v-toolbar dark color="#001e46">
					<v-toolbar-title style="color: rgba(129, 182, 228, 0.95)">
					  {{ !indicatorDialog.edit ? 'Просмотр показателя' : 'Редактирование симптомов' }}
					</v-toolbar-title>

					<v-spacer></v-spacer>

					<v-toolbar-items>
						<v-btn icon color="rgba(129, 182, 228, 0.95)" @click="closeIndicator">
							<v-icon>mdi-close</v-icon>
						</v-btn>
					</v-toolbar-items>
				</v-toolbar>

				<v-card-text>
					<v-container>
            <v-row>
              <v-col cols="12" sm="12" md="12">
                <div class="mt-3 ml-3 text-subtitle-1 text--primary">
                  {{ indicatorDialog.pathology.name }} ({{ indicatorDialog.pathology.code }})
                </div>
              </v-col>
            </v-row>
						<v-form ref="indicatorForm" v-model="indicatorDialog.valid" lazy-validation>
							<v-row>
								<v-col cols="12" sm="12" md="12" class="mt-5">
									<v-text-field :rules="[rules.required]" outlined dense hide-details v-model="indicatorDialog.target.indicatorName" disabled label="Наименование показателя" />
								</v-col>
								<v-col cols="12" sm="12" md="12">
									<v-select :rules="[rules.required]" outlined dense hide-details item-text="name" item-value="id" :items="groupsList" v-model="indicatorDialog.target.propertyGroupId" disabled label="Группа" />
								</v-col>
                <v-col cols="12" sm="12" md="12">
									<v-select outlined dense hide-details item-text="name" item-value="id" :items="gendersList" v-model="symptomsDialog.gender" disabled label="Пол" />
								</v-col>
								<v-col cols="12" sm="12" md="12">
                  <template v-for="indicator in indicatorDialog.target.propertyDataList">
                    <v-row :key="indicator.id">
                      <v-col cols="2" sm="2" md="2" align-self="start">
                        <v-text-field type="number" :rules="[rules.required]" outlined dense hide-details v-model="indicator.ageOnMonth" disabled label="Возраст(мес)" /> 
                      </v-col>
                      <v-col class="mt-2" cols="5" sm="5" :md="indicator.valueType != 3 ? 3 : 5" align-self="start">
                        <v-radio-group dense hide-details v-model="indicator.valueType" row disabled>
                          <v-radio label="Диапазон" :value="1" />
                          <v-radio label="Значение" :value="2" />
                          <v-radio v-if="indicator.valueType == 3" label="Справочник" :value="3" />
                        </v-radio-group>
                      </v-col>
                      <v-col cols="5" sm="5" :md="indicator.valueType != 3 ? 7 : 5">
                        <!-- Диапазон -->
                        <v-row v-if="indicator.valueType == 1">
                          <v-col cols="3" sm="3" :md="analyzerEnabled ? 2 : 3">
                            <v-text-field type="number" :rules="[rules.required, indicator.minValue && indicator.maxValue ? rules.rangeFromTo(+indicator.minValue, +indicator.maxValue) : true]" outlined dense hide-details v-model="indicator.minValue" disabled label="От" /> 
                          </v-col>
                          <v-col cols="3" sm="3" :md="analyzerEnabled ? 2 : 3">
                            <v-text-field type="number" :rules="[rules.required, indicator.minValue && indicator.maxValue ? rules.rangeFromTo(+indicator.minValue, +indicator.maxValue) : true]" outlined dense hide-details v-model="indicator.maxValue" disabled label="До" /> 
                          </v-col>
                          <v-col 
                              :cols="!indicatorDialog.edit ? (analyzerEnabled ? 5 : 6) : (analyzerEnabled ? 4 : 5)" 
                              :sm="!indicatorDialog.edit ? (analyzerEnabled ? 5 : 6) : (analyzerEnabled ? 4 : 5)" 
                              :md="!indicatorDialog.edit ? (analyzerEnabled ? 5 : 6) : (analyzerEnabled ? 4 : 5)"
                          >
                            <v-autocomplete :rules="[rules.required]" outlined dense hide-details :items="measurementsList" v-model="indicator.measurement" disabled label="Ед.измерения" />
                          </v-col>
                          <v-col v-if="analyzerEnabled" :cols="!indicatorDialog.edit ? 4 : 3" :sm="!indicatorDialog.edit ? 4 : 3" :md="!indicatorDialog.edit ? 4 : 3">
                            <v-autocomplete outlined dense hide-details :items="analyzers" item-value="id" item-text="name" v-model="indicator.analyzerId" disabled label="Анализатор" />
                          </v-col>
                          <v-col v-if="indicatorDialog.edit" cols="1" sm="1" md="1">
                            <v-tooltip bottom>
                              <template v-slot:activator="{ on, attrs }">
                                <v-icon @click="addSymptomRow(indicator, symptomsDialog.pathology.id)" v-bind="attrs" v-on="on" color="error" class="mt-2">mdi-plus-circle</v-icon>
                              </template>
                              <span>Добавить симптом</span>
                            </v-tooltip>
                          </v-col>
                        </v-row>
                        <!-- Значение -->
                        <v-row v-if="indicator.valueType == 2">
                          <v-col 
                            :cols="!indicatorDialog.edit ? (analyzerEnabled ? 8 : 12) : (analyzerEnabled ? 7 : 11)" 
                            :sm="!indicatorDialog.edit ? (analyzerEnabled ? 8 : 12) : (analyzerEnabled ? 7 : 11)" 
                            :md="!indicatorDialog.edit ? (analyzerEnabled ? 8 : 12) : (analyzerEnabled ? 7 : 11)"
                          >
                            <v-text-field :rules="[rules.required]" outlined dense hide-details v-model="indicator.dictionaryValue" disabled label="Значение" /> 
                          </v-col>
                          <v-col v-if="analyzerEnabled" :cols="!indicatorDialog.edit ? 4 : 3" :sm="!indicatorDialog.edit ? 4 : 3" :md="!indicatorDialog.edit ? 4 : 3">
                            <v-autocomplete outlined dense hide-details :items="analyzers" item-value="id" item-text="name" v-model="indicator.analyzerId" label="Анализатор" />
                          </v-col>
                          <v-col v-if="indicatorDialog.edit" cols="1" sm="1" md="1">
                            <v-tooltip bottom>
                              <template v-slot:activator="{ on, attrs }">
                                <v-icon @click="addSymptomRow(indicator, symptomsDialog.pathology.id)" v-bind="attrs" v-on="on" color="error" class="mt-2">mdi-plus-circle</v-icon>
                              </template>
                              <span>Добавить симптом</span>
                            </v-tooltip>
                          </v-col>
                        </v-row>
                        <!-- Справочник -->
                        <v-row v-if="indicator.valueType == 3">
                          <v-col :cols="!indicatorDialog.edit ? 12 : 11" :sm="!indicatorDialog.edit ? 12 : 11" :md="!indicatorDialog.edit ? 12 : 11">
                            <v-autocomplete
                              class="white-space-select"
                              outlined
                              multiple
                              hide-details
                              return-object
                              item-value="dictionaryValueId"
                              item-text="value"
                              :items="indicatorDialog.referenceValuesList"
                              v-model="indicator.valueList"
                              disabled
                              label="Список из справочника"
                            />
                          </v-col>
                          <v-col v-if="indicatorDialog.edit" cols="1" sm="1" md="1">
                            <v-tooltip bottom>
                              <template v-slot:activator="{ on, attrs }">
                                <v-icon @click="addSymptomRow(indicator, symptomsDialog.pathology.id)" v-bind="attrs" v-on="on" color="error" class="mt-2">mdi-plus-circle</v-icon>
                              </template>
                              <span>Добавить симптом</span>
                            </v-tooltip>
                          </v-col>
                        </v-row>
                      </v-col>
									  </v-row>

                    <v-row v-for="(symptom, key) in indicator.symptoms" :key="'symptom_' + indicator.id + '_' + key">
                      <v-col cols="7" sm="7" :md="symptom.valueType != 3 ? 5 : 7">
                      </v-col>
                      <!-- <v-col cols="3" sm="3" :md="symptom.valueType != 3 ? 3 : 5" align-self="start" class="mt-2">
                        <div style="display: flex;">
                          <v-checkbox v-model="symptom.genders" :value="0" hide-details class="mr-5" label="Мужчина"></v-checkbox>
                          <v-checkbox v-model="symptom.genders" :value="1" hide-details label="Женщина"></v-checkbox>
                        </div>
                      </v-col> -->
                      <v-col cols="5" sm="5" :md="symptom.valueType != 3 ? 7 : 5">
                        <!-- Диапазон -->
                        <v-row v-if="symptom.valueType == 1">
                          <v-col cols="3" sm="3" :md="analyzerEnabled ? 2 : 3">
                            <v-text-field type="number" :rules="[rules.required, symptom.minValue && symptom.maxValue ? rules.rangeFromTo(+symptom.minValue, +symptom.maxValue) && !rules.overlapNormRange(indicator, symptom) : true]" outlined dense hide-details v-model="symptom.minValue" label="От" /> 
                          </v-col>
                          <v-col cols="3" sm="3" :md="analyzerEnabled ? 2 : 3">
                            <v-text-field type="number" :rules="[rules.required, symptom.minValue && symptom.maxValue ? rules.rangeFromTo(+symptom.minValue, +symptom.maxValue) && !rules.overlapNormRange(indicator, symptom) : true]" outlined dense hide-details v-model="symptom.maxValue" label="До" /> 
                          </v-col>
                          <v-col cols="6" sm="6" :md="analyzerEnabled ? 8 : 6" class="text-right">
                            <v-tooltip bottom>
                              <template v-slot:activator="{ on, attrs }">
                                <v-icon @click="deleteSymptomRow(indicator, key)" v-bind="attrs" v-on="on" color="error" class="mt-2" style="margin-right: 7px;">mdi-delete</v-icon>
                              </template>
                              <span>Удалить симптом</span>
                            </v-tooltip>
                          </v-col>
                        </v-row>
                        <!-- Значение -->
                        <v-row v-if="symptom.valueType == 2">
                          <v-col :cols="analyzerEnabled ? 7 : 11" :sm="analyzerEnabled ? 7 : 11" :md="analyzerEnabled ? 7 : 11">
                            <v-text-field :rules="[rules.required, rules.differFromNorm(indicator, symptom)]" outlined dense hide-details v-model="symptom.dictionaryValue" label="Значение" /> 
                          </v-col>
                          <v-col cols="1" sm="1" md="1">
                            <v-tooltip bottom>
                              <template v-slot:activator="{ on, attrs }">
                                <v-icon @click="deleteSymptomRow(indicator, key)" v-bind="attrs" v-on="on" color="error" class="mt-2 mr-2">mdi-delete</v-icon>
                              </template>
                              <span>Удалить симптом</span>
                            </v-tooltip>
                          </v-col>
                        </v-row>
                        <!-- Справочник -->
                        <v-row v-if="symptom.valueType == 3">
                          <v-col cols="11" sm="11" md="11">
                            <v-autocomplete
                              class="white-space-select"
                              outlined
                              multiple
                              hide-details
                              return-object
                              item-value="dictionaryValueId"
                              item-text="value"
                              :items="symptom.referenceValuesList"
                              v-model="symptom.valueList"
                              label="Список из справочника"
                            />
                          </v-col>
                          <v-col cols="1" sm="1" md="1">
                            <v-tooltip bottom>
                              <template v-slot:activator="{ on, attrs }">
                                <v-icon @click="deleteSymptomRow(indicator, key)" v-bind="attrs" v-on="on" color="error" class="mt-2 mr-2">mdi-delete</v-icon>
                              </template>
                              <span>Удалить симптом</span>
                            </v-tooltip>
                          </v-col>
                        </v-row>
                      </v-col>
                    </v-row>
                  </template>
								</v-col>
							</v-row>
						</v-form>
					</v-container>
				</v-card-text>

				<v-card-actions v-if="indicatorDialog.edit">
					<v-spacer></v-spacer>
					<v-btn :loading="sendingRequest" @click="!sendingRequest ? closeIndicator() : ''" color="blue darken-1" dark>Отмена</v-btn>
					<v-btn :loading="sendingRequest" @click="!sendingRequest ? saveIndicator(indicatorDialog.target) : ''" color="success" dark>Сохранить</v-btn>
				</v-card-actions>
			</v-card>
		</v-dialog>

    <v-dialog v-model="symptomsDialog.show" max-width="900px" persistent>
      <v-toolbar dark color="#001e46">
        <v-toolbar-title style="color: rgba(129, 182, 228, 0.95)">
          Редактор симптомов заболевания
        </v-toolbar-title>

        <v-spacer></v-spacer>

        <v-toolbar-items>
          <v-btn icon color="rgba(129, 182, 228, 0.95)" @click="closeSymptoms">
            <v-icon>mdi-close</v-icon>
          </v-btn>
        </v-toolbar-items>
      </v-toolbar>

      <v-card>       
        <v-card-text>
          <v-row>
            <v-col cols="12" sm="12" md="12">
              <div class="mt-3 ml-3 text-subtitle-1 text--primary">
                {{ symptomsDialog.pathology.name }} ({{ symptomsDialog.pathology.code }})
              </div>
            </v-col>
          </v-row>
          <v-row>
            <v-col cols="12" sm="12" md="12">
              <v-radio-group dense hide-details v-model="symptomsDialog.gender" row @change="updateBodySystems()">
                <v-radio v-for="gender in gendersList" :key="gender.id" :label="gender.name" :value="gender.id" />
              </v-radio-group>
            </v-col>
          </v-row>
          <v-row>
            <v-col cols="12" sm="12" md="12">
              <v-select outlined dense hide-details item-text="name" item-value="nodeId" :items="systemsList" v-model="symptomsDialog.systemId" @change="updateIndicators()" label="Система" />
            </v-col>
          </v-row>
          <v-row>
            <v-col cols="12" sm="12" md="12">
              <table style="width: 100%" class="elevation-2">
                <tbody>
                  <template v-for="(group, key) in symptomsDialog.indicatorGroups">
                    <tr :key="'group_' + group.id + '_' + key" class="border-bottom: 1px gray solid">
                      <td style="padding: 10px 16px;">
                        <v-btn @click="openIndicatorGroup(key)" small icon>
                          <v-icon>
                            {{ group.isOpen ? 'mdi-chevron-down' : 'mdi-chevron-right' }}
                          </v-icon>
                        </v-btn>
                        <span>{{ group.name }}</span>
                      </td>
                    </tr>
                    <tr v-if="group.isOpen" :key="group.id">
                      <td style="padding: 10px 16px;">
                        <table style="width: 100%" class="elevation-2">
                          <tbody>
                            <tr v-for="indicator in group.indicators" :key="indicator.id" class="border-bottom: 1px gray solid">
                              <td class="td-is-open px-3">
                                {{ indicator.indicatorName }} <a v-if="indicator.symptomsCount > 0" @click="openIndicator(indicator, symptomsDialog.pathology, true)">({{ indicator.symptomsCount }})</a>
                              </td>
                              <td class="td-is-open" style="text-align: end;">
                                <v-tooltip bottom>
                                  <template v-slot:activator="{ on, attrs }">
                                    <v-icon @click="openIndicator(indicator, symptomsDialog.pathology, true)" v-bind="attrs" v-on="on" class="mr-2">mdi-pencil-box-outline</v-icon>
                                  </template>
                                  <span>Редактировать</span>
                                </v-tooltip>
                              </td>
                            </tr>
                          </tbody>
                        </table>
                      </td>
                    </tr>
                  </template>
                </tbody>
              </table>
            </v-col>
          </v-row>
        </v-card-text>
      </v-card>
    </v-dialog>

  </div>    
</template>

<script>
import { mapActions, mapGetters } from "vuex";
import _ from 'lodash'
import "./index.scss";
import { required } from 'vee-validate/dist/rules'
import { extend, ValidationObserver, ValidationProvider, setInteractionMode } from 'vee-validate'
setInteractionMode('eager')
extend('required', {
  ...required,
  message: '{_field_} Заполните поле',
})

export default {
    name: 'DirectoryOfDiseases',
    components: {
      ValidationProvider,
      ValidationObserver,
    },
    data: () => ({
      loadingTable: false,
      sendingRequest: false,
      tableKey: 0,
      headers: [
        { text: '', value: 'expandSubtypes', width: '60px', sortable: false },
        { text: 'Код', value: 'code', width: '72px' },
        // { text: 'Симптомы', value: 'expandSymptoms', width: '95px', sortable: false },
        { text: 'Название', value: 'name' },
        { text: '', value: 'actions', sortable: false }
      ],
      pagination: {
        sortBy: 'name'
      },
      page: 1,
      itemsPerPage: 10,
      search: '',
      pathologyDialog: {
        show: false,
        target: {},
        update: false,
        valid: true
      },
      indicatorDialog: {
        show: false,
        pathology: {},
        target: {},
        referenceValuesList: [],
        update: false,
        valid: true
      },
      symptomsDialog: {
        show: false,
        pathology: {},
        gender: 0,
        systemId: 0,
        indicatorGroups: []
      },
      groupsList: [],
      measurementsList: [],
      systemsList: [],
      analyzerEnabled: false,
      rules: {
        required: v => (!!v || v === 0) || 'Обязательно для заполнения!',
        rangeFromTo: (a, b) => {
          if (a > b) return false;
          if (a < b) return true;
          if (a === b) return true;
          return false
        },
        differFromNorm: (indicator, symptom) => {
          return indicator.dictionaryValue != symptom.dictionaryValue
        },
        overlapNormRange: (indicator, symptom) => {
          return (indicator.minValue < symptom.maxValue && symptom.minValue < indicator.maxValue) || 
            (indicator.minValue == symptom.minValue && indicator.maxValue == symptom.maxValue)
        }
      },
    }),

    created () {
      this.getGenders();
      this.getPathologies(true);
      this.getAnalyzers();
    },

    computed: {
      ...mapGetters({
        apiUrl: 'apiUrl',
        gendersList: 'property/genders',
        pathologiesData: "property/pathologies",
        analyzers: 'tree/analyzers'
      }),
    },
    watch: {
      'symptomsDialog.systemId'(systemId) {
        let system = this.systemsList.find(x => x.nodeId === systemId);

        if (system !== undefined) {
          this.analyzerEnabled = system.name === 'Лабораторные исследования';
        }
      }
    },
    methods: {
      ...mapActions({
        getGenders: 'property/getGenders',
        getPathologies: 'property/getPathologies',
        getAnalyzers: 'tree/getAnalyzers'
      }),
      paginations(event) {
        this.page = event.page
        this.itemsPerPage = event.itemsPerPage
      },
      idIsEmpty(id) {
        return id === undefined || id === null || id.length === 0 || id === '00000000-0000-0000-0000-000000000000';
      },
      addSubtype(pathology) {
        this.pathologyDialog.show = true
        this.pathologyDialog.update = false
        this.pathologyDialog.target = {
          id: undefined,
          name: pathology.name,
          code: pathology.code,
          note: null,
          parentId: pathology.id
        }
      },
      editPathology(id) {
        this.$http.get(`${this.apiUrl}Pathology/Get?id=${id}`)
          .then(response => {
            this.pathologyDialog.target = response.data
            this.pathologyDialog.show = true
            this.pathologyDialog.update = true
          })
      },
      savePathology(pathology) {
        if(this.$refs.pathologyForm.validate()) {
          this.sendingRequest = true;

          this.$http.post(`${this.apiUrl}Pathology/${this.pathologyDialog.update ? 'Update' : 'Add'}`, {
            id: pathology.id,
            name: pathology.name,
            code: pathology.code,
            note: pathology.note !== null && pathology.note.length > 0 ? pathology.note : null,
            parentId: pathology.parentId
          }).then(response => {
            if (response.status === 200) {
              let parent = this.pathologiesData.find(x => x.id === response.data.parentId)

              if (!this.pathologyDialog.update) {
                let added = response.data
                added.openSubtypes = false
                added.openSymptoms = false
                parent.subtypes.push(added)
              }
              else {
                let updated = parent.subtypes.find(x => x.id === response.data.id)
                updated.note = response.data.note
              }

              this.closePathology()
            }
            else {
              alert('Такое примечание уже существует.')
              this.sendingRequest = false
            }
            
          }, response => {
            alert('Произошла ошибка. Данные не были сохранены.')
            this.sendingRequest = false
          })
        }
      },
      closePathology() {
        this.$refs.pathologyForm.reset()
        this.pathologyDialog.target = {}
        this.pathologyDialog.show = false
        this.sendingRequest = false
      },
      openIndicator(indicator, pathology, edit) {
        this.$http.get(`${this.apiUrl}Property/GetGroupsByNode?nodeid=${indicator.treeItemId}`)
				  .then(response => {
					  this.groupsList = response.data
				  })

        this.$http.get(`${this.apiUrl}Property/GetMeasurements`)
          .then(response => {
            this.measurementsList = response.data
          })

        this.indicatorDialog.edit = edit
        this.indicatorDialog.pathology = pathology
        this.indicatorDialog.target = JSON.parse(JSON.stringify(indicator));
        this.indicatorDialog.target.pathologyId = pathology.id

        if (this.indicatorDialog.edit) {
          this.indicatorDialog.target.propertyDataList.forEach(x => {
            x.symptoms = x.symptoms.filter(x => x.pathologyId === pathology.id)
          })
        }

        if (indicator.propertyDataList.length > 0 && indicator.propertyDataList[0].valueType === 3) {
          this.$http.get(`${this.apiUrl}Property/GetDictionaryValueForPropertyId?propertyid=${indicator.propertyDataList[0].id}`)
            .then(response => {
              response.data.forEach(x => { 
                x.dictionaryValueId = x.id, 
                x.dictionaryValue = x.value 
              })

              this.indicatorDialog.referenceValuesList = response.data

              if (this.indicatorDialog.edit) {
                this.indicatorDialog.target.propertyDataList.forEach(x => {
                  let normValues = x.valueList.map(x => x.dictionaryValueId)

                  x.symptoms.forEach(y => {
                    y.referenceValuesList = this.indicatorDialog.referenceValuesList.filter(z => !normValues.includes(z.dictionaryValueId))
                  })
                })
              }
            })
        }

        this.indicatorDialog.show = true
      },
      closeIndicator() {
        this.indicatorDialog.show = false
        this.indicatorDialog.target = {}
        this.indicatorDialog.referenceValuesList = []
        this.sendingRequest = false
      },
      openSymptoms(pathology) {
        if (this.gendersList.length === 0) {
          return;
        }

        this.symptomsDialog.gender = this.gendersList[0].id
        this.updateBodySystems()
        
        this.symptomsDialog.pathology = Object.assign({}, pathology)
        this.symptomsDialog.show = true
      },
      updateBodySystems() {
        this.$http.get(`${this.apiUrl}BodyTree/GetSystemNodes?humanId=${this.symptomsDialog.gender}`)
				  .then(response => {
            let previousSystem = null

            if (!this.idIsEmpty(this.symptomsDialog.systemId)) {
              previousSystem = this.systemsList.find(x => x.nodeId === this.symptomsDialog.systemId)
            }

					  this.systemsList = response.data

            let currentSystem = null

            if (previousSystem !== undefined && previousSystem !== null) {
              currentSystem = this.systemsList.find(x => x.name === previousSystem.name)
            }

            if (currentSystem === undefined || currentSystem === null) {
              currentSystem = this.systemsList.find(x => x.name === 'Дыхательная система')
            }

            if (currentSystem !== undefined) {
              this.symptomsDialog.systemId = currentSystem.nodeId
              this.updateIndicators()
            }
				  })
      },
      updateIndicators() {
        let allGenders = !this.idIsEmpty(this.symptomsDialog.gender) ? false : true;

        this.$http.get(`${this.apiUrl}Pathology/GetNormsByNode?nodeId=${this.symptomsDialog.systemId}&allGenders=${allGenders}`)
				  .then(response => {

					  this.symptomsDialog.indicatorGroups = response.data

            this.symptomsDialog.indicatorGroups.forEach(group => {
              group.isOpen = false

              group.indicators.forEach(indicator => {
                indicator.symptomsCount = 0

                indicator.propertyDataList.forEach(x => {
                  x.symptoms.forEach(symptom => {
                    if (symptom.pathologyId === this.symptomsDialog.pathology.id) {
                      indicator.symptomsCount++
                    }
                  })
                })
              })
            })
				  })
      },
      openIndicatorGroup(key) {
        let group = this.symptomsDialog.indicatorGroups[key];
        group.isOpen = !group.isOpen;
        this.$set(this.symptomsDialog.indicatorGroups, key, group);
      },
      closeSymptoms() {
        this.symptomsDialog.show = false
      },
      addSymptomRow(indicator, pathologyId) {
        let symptom = Object.assign({}, indicator)
        symptom.id = undefined
        symptom.isNormal = false
        symptom.pathologyId = pathologyId
        symptom.symptoms = []
        symptom.genders = [0, 1]
        symptom.minValue = null
        symptom.maxValue = null
        symptom.dictionaryValue = null
        symptom.valueList = []

        let normValues = indicator.valueList.map(x => x.dictionaryValueId)
        symptom.referenceValuesList = this.indicatorDialog.referenceValuesList.filter(x => !normValues.includes(x.dictionaryValueId))

        indicator.symptoms.push(symptom)
      },
      deleteSymptomRow(indicator, index) {
        if (confirm('Вы уверены, что хотите удалить?')) {
          indicator.symptoms.splice(index, 1)
        }
      },
      saveIndicator(indicator) {
        if (this.$refs.indicatorForm.validate()) {
          this.sendingRequest = true;

          let allGenders = !this.idIsEmpty(this.symptomsDialog.gender) ? false : true;

          this.$http.post(`${this.apiUrl}Pathology/UpdateSymptoms?allGenders=${allGenders}`, indicator)
            .then(response => {
              let pathology = null

              if (this.idIsEmpty(this.indicatorDialog.pathology.parentId)) {
                pathology = this.pathologiesData.find(x => x.id == indicator.pathologyId)
              }
              else {
                let parent = this.pathologiesData.find(x => x.id === this.indicatorDialog.pathology.parentId)
                pathology = parent.subtypes.find(x => x.id === indicator.pathologyId)
              }
              
              pathology.symptoms = response.data
              this.updateIndicators()
              this.closeIndicator()
              this.sendingRequest = false
            }, response => {
              alert('Произошла ошибка. Данные не были сохранены.')
              this.sendingRequest = false
            })
        }
      }
    }
  }
</script>
